function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Loads and initialises Paddle.js (Billing) once per page.
 *
 * Shared by everything that opens a Paddle checkout, so that the script is only ever injected
 * once and `Paddle.Initialize()` - which Paddle only honours the first time - is called from
 * one place.
 */
var SCRIPT_ID = 'paddleBillingScript';
var POLL_INTERVAL_MS = 100;
var INITIALISE_TIMEOUT_MS = 15000;
var PADDLE_LOCALES = {
  br: 'pt',
  cn: 'zh-Hans',
  es: 'es',
  jp: 'ja'
};
export var paddleLocaleFor = function paddleLocaleFor(siteLanguage) {
  return PADDLE_LOCALES[siteLanguage] || 'en';
};
var whenInitialised = function whenInitialised() {
  return new Promise(function (resolve, reject) {
    var _window$Paddle;
    if ((_window$Paddle = window.Paddle) !== null && _window$Paddle !== void 0 && _window$Paddle.Initialized) {
      resolve(window.Paddle);
      return;
    }
    var interval = null;
    var timeout = setTimeout(function () {
      clearInterval(interval);
      reject(new Error('Paddle init timeout'));
    }, INITIALISE_TIMEOUT_MS);
    interval = setInterval(function () {
      var _window$Paddle2;
      if ((_window$Paddle2 = window.Paddle) !== null && _window$Paddle2 !== void 0 && _window$Paddle2.Initialized) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve(window.Paddle);
      }
    }, POLL_INTERVAL_MS);
  });
};

/**
 * Resolves with `window.Paddle` once it is ready to open a checkout.
 *
 * `checkoutSettings` become the page's default checkout settings. They matter for a checkout
 * that Paddle.js opens by itself - which it does when the URL carries a `_ptxn` transaction -
 * since that checkout has no `Paddle.Checkout.open()` call of ours to take settings from.
 */
export var ensurePaddleInitialised = function ensurePaddleInitialised(_ref) {
  var _window$Paddle3;
  var scriptUrlv2 = _ref.scriptUrlv2,
    clientToken = _ref.clientToken,
    environment = _ref.environment,
    _ref$customerPaddleId = _ref.customerPaddleId,
    customerPaddleId = _ref$customerPaddleId === void 0 ? null : _ref$customerPaddleId,
    eventCallback = _ref.eventCallback,
    _ref$checkoutSettings = _ref.checkoutSettings,
    checkoutSettings = _ref$checkoutSettings === void 0 ? null : _ref$checkoutSettings;
  if ((_window$Paddle3 = window.Paddle) !== null && _window$Paddle3 !== void 0 && _window$Paddle3.Initialized || document.getElementById(SCRIPT_ID)) {
    return whenInitialised();
  }
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = scriptUrlv2;
    script.onload = function () {
      if (!window.Paddle) {
        reject(new Error('Paddle object not found after script load'));
        return;
      }
      if (environment === 'sandbox') {
        window.Paddle.Environment.set('sandbox');
      }
      window.Paddle.Initialize(_objectSpread({
        token: clientToken,
        pwCustomer: customerPaddleId ? {
          id: customerPaddleId
        } : {},
        eventCallback: eventCallback
      }, checkoutSettings ? {
        checkout: {
          settings: checkoutSettings
        }
      } : {}));
      whenInitialised().then(resolve, reject);
    };
    script.onerror = function () {
      return reject(new Error('Failed to load Paddle script'));
    };
    document.body.appendChild(script);
  });
};